import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useMemo, useState } from "react";
import TableContainer from "../../../../components/TableContainer/TableContainer";
import styles from "./FinanceLaunch.module.css";

interface LaunchData {
    uid_financeiro_lancamento: string;
    codigo_interno?: string | number;
    codigo_estabelecimento?: string | number;
    pessoa?: { nome: string };
    descricao: string;
    numero_documento?: string;
    valor_total: number | string;
    tipo: string;
    data_vencimento: string;
}

interface FinanceLaunchProps {
    data?: LaunchData | null;
}

const FinanceLaunch = ({ data }: FinanceLaunchProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const formatCurrency = (value: number | string) => {
        const num = Number(value);
        return isNaN(num)
            ? "R$ 0,00"
            : num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    };

    const formatDate = (dateString: string) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    };

    const columns = [
        { key: "codigo", titulo: "Cód.", classStyle: styles.columnCode },
        { key: "fornecedor", titulo: "Forn./Cli.", classStyle: styles.columnProvider },
        { key: "descricao", titulo: "Descrição", classStyle: styles.columnDesc },
        { key: "doc", titulo: "Doc.", classStyle: styles.columnDoc },
        { key: "valor", titulo: "Valor", classStyle: styles.columnValue },
        { key: "tipo", titulo: "Tipo", classStyle: styles.columnType },
        { key: "vencimento", titulo: "Venc.", classStyle: styles.columnDate },
    ];

    const content = useMemo(() => {
        if (!data) return [];

        return [
            {
                values: {
                    codigo: data.codigo_interno || data.codigo_estabelecimento || String(data.uid_financeiro_lancamento).slice(0, 6),
                    fornecedor: data.pessoa?.nome || "---",
                    descricao: data.descricao || "---",
                    doc: data.numero_documento || "---",
                    valor: formatCurrency(data.valor_total),
                    tipo: data.tipo === "pagar" ? "A Pagar" : "A Receber",
                    vencimento: formatDate(data.data_vencimento),
                },
                buttons: [],
                onClick: undefined,
            },
        ];
    }, [data]);

    return (
        <div className={styles.containerLaunch}>
            <div className={styles.headerLaunch} onClick={toggleOpen}>
                <h2>Lançamento</h2>

                <div className={styles.iconIndicator}>
                    {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </div>
            </div>

            {isOpen && (
                <div className={styles.contentLaunch}>
                    <div className={styles.tableLaunch}>
                        <TableContainer
                            columns={columns}
                            content={content}
                            responsive={true}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default FinanceLaunch;